import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '@components/dropdown';
import { Filter } from '@components/table/filter';
import { HrFlexContainer } from '@components/styles/hr-styles';
import { OPTIONS_FILTER_VACANCY_REQUEST } from '../../../constant/vacancy-request';

export const FilterRequestTable = ({ tableInstance, setFilter, total }) => {
  const [t] = useTranslation();
  const [status, setStatus] = useState(0);

  const {
    rows,
    state: { pageSize }
  } = tableInstance;

  const inputFilter = (e) => {
    setFilter({
      status,
      search: e.target.value,
      pageSize,
      pageIndex: 0
    });
  };

  const dropDowFilter = (value) => {
    setFilter((prev) => {
      return { ...prev, status: value.value, pageIndex: 0 };
    });
  };

  return (
    <HrFlexContainer flexWrap='nowrap'>
      <Dropdown
        options={OPTIONS_FILTER_VACANCY_REQUEST}
        setSelection={setStatus}
        label={t('requestVacancies.colaborativeSelection.filter.dropdown')}
        dropDowFilter={dropDowFilter}
      />
      <Filter
        placeholder={t('requestVacancies.colaborativeSelection.filter.placeholder')}
        inputFilter={inputFilter}
        rows={rows}
        total={total}
        filterText={t('requestVacancies.colaborativeSelection.filter.filterText')}
      />
    </HrFlexContainer>
  );
};
